import './Preview.css';

function Preview() {
  return (
    <div className="Preview">
      <div className="Preview-container">
        <h1>UI Components Preview</h1>

        <section className="Preview-section">
          <h2>Typography</h2>
          <h1>Heading 1</h1>
          <h2>Heading 2</h2>
          <h3>Heading 3</h3>
          <p>This is a paragraph with regular text. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          <p className="text-muted">This is muted text for secondary information.</p>
        </section>

        <section className="Preview-section">
          <h2>Buttons</h2>
          <button className="btn btn-primary">Primary Button</button>
          <button className="btn btn-secondary">Secondary Button</button>
          <button className="btn btn-outline">Outline Button</button>
          <button className="btn btn-primary" disabled>Disabled Button</button>
        </section>

        <section className="Preview-section">
          <h2>Links</h2>
          <a href="#" className="link">Standard Link</a>
          <a href="#" className="link link-muted">Muted Link</a>
        </section>

        <section className="Preview-section">
          <h2>Cards</h2>
          <div className="card">
            <h3>Card Title</h3>
            <p>Card content goes here. This is a standard card component with a dark background.</p>
            <button className="btn btn-primary">Action</button>
          </div>
        </section>

        <section className="Preview-section">
          <h2>Navigation</h2>
          <nav className="nav">
            <a href="#" className="nav-link">About</a>
            <a href="#" className="nav-link">Articles</a>
            <a href="#" className="nav-link">Knowledge Base</a>
          </nav>
        </section>

        <section className="Preview-section">
          <h2>Form Elements</h2>
          <form className="form">
            <div className="form-group">
              <label htmlFor="input1">Input Field</label>
              <input type="text" id="input1" className="form-input" placeholder="Enter text..." />
            </div>
            <div className="form-group">
              <label htmlFor="textarea1">Text Area</label>
              <textarea id="textarea1" className="form-input" rows="4" placeholder="Enter longer text..."></textarea>
            </div>
            <div className="form-group">
              <label htmlFor="select1">Select Dropdown</label>
              <select id="select1" className="form-input">
                <option>Option 1</option>
                <option>Option 2</option>
                <option>Option 3</option>
              </select>
            </div>
          </form>
        </section>

        <section className="Preview-section">
          <h2>Alert Messages</h2>
          <div className="alert alert-info">This is an info alert message.</div>
          <div className="alert alert-success">This is a success alert message.</div>
          <div className="alert alert-warning">This is a warning alert message.</div>
          <div className="alert alert-error">This is an error alert message.</div>
        </section>

        <section className="Preview-section">
          <h2>Code Blocks</h2>
          <code className="code-inline">inline code</code>
          <pre className="code-block">
{`function example() {
  console.log('Hello, cybersmith.io!');
  return true;
}`}
          </pre>
        </section>
      </div>
    </div>
  );
}

export default Preview;
